<!--
 * @Author: likk
 * @Date: 2023-09-05 17:49:34
 * @LastEditTime: 2024-03-21 21:56:54
 * @LastEditors: likk 1126919170@qq.com
 * @Description: 供需信息查询
-->
<template>
  <router-view />
</template>

<script>
export default {
  name: "GXInfoQuery",
};
</script>
<style lang="scss" scoped>
  
</style>